<template>
  <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" class="w-auto" :class="height">
    <title><slot /></title>
    <path d="M6 18L18 6M6 6l12 12" />
  </svg>
</template>

<script>
export default {
  name: 'BaseClose',

  props: {
    size: {
      type: String,
      default: 'h-4'
    }
  },

  computed: {
    height() {
      return this.size
    }
  }
}
</script>
